import React from 'react'

export const presets = {
  szenarios: [
    {
      data: {
        roomVolume: 300,
        airExchangeRate: 1.5,
        timeInRoom: 180,
        maskEfficiencyExhaled: 0,
        maskEfficiencyInhaled: 0,
        emitterType: 'very',
        activityLevel: 'low',
        voiceStrengths: [0.4, 0.5, 0.1],
        criticalDose: 500
      },
      name: 'Restaurant',
      desc: '',

      icon: 'party',
      text: (
        <>
          Le restaurant fait environ 300m³ et dispose d’une puissante
          ventilation. Les clientes et les clients mangent pendant environ trois
          heures et ne portent pas de masques. Assis, ils sont peu actifs; leurs
          conversations ont lieu à volume normal et le débit de parole reste
          modéré. Une personne très contagieuse est présente dans la pièce.
        </>
      )
    },
    {
      data: {
        roomVolume: 50,
        airExchangeRate: 2,
        timeInRoom: 15,
        maskEfficiencyExhaled: 0.75,
        maskEfficiencyInhaled: 0.75,
        emitterType: 'very',
        activityLevel: 'medium',
        voiceStrengths: [1, 0, 0],
        criticalDose: 500
      },
      name: 'Salle d’attente',
      desc: 'chez le médecin',
      icon: 'doctor',
      text: (
        <>
          La salle d'attente d'un cabinet médical n'est souvent pas très grande.
          Dans cet exemple précis, elle mesure environ 50m³. Grâce à de brèves
          aérations régulières, l'air est complètement renouvelé deux fois par
          heure. Les patientes et patients en attente passent en moyenne 15
          minutes dans la salle et portent tous des masques d’hygiène (ou
          masques chirurgicaux) ordinaires, disponibles en magasin. Il règne une
          activité d’intensité moyenne dans la pièce en raison des va-et-vient
          des patientes et des patients. Presque personne ne parle, ce qui
          maintient un très faible débit de parole. Le risque de transmission du
          Covid-19 provient d'une personne très contagieuse.{' '}
        </>
      )
    },
    {
      data: {
        roomVolume: 150,
        airExchangeRate: 6,
        timeInRoom: 45,
        maskEfficiencyExhaled: 0.75,
        maskEfficiencyInhaled: 0,
        emitterType: 'very',
        activityLevel: 'low',
        voiceStrengths: [0.4, 0.5, 0.1],
        criticalDose: 500
      },
      name: 'Salle de classe',
      desc: 'en cours',

      icon: 'school',
      text: (
        <>
          La salle de classe mesure environ 150m³ et dispose d’une ventilation
          puissante. Les élèves ne portent pas de masque et passent 45 minutes
          par cours dans la salle. Pendant la leçon, ils bougent peu, mais
          parlent beaucoup, à volume variable. Cela entraîne un débit de parole
          relativement élevé. Les aérosols dangereux sont émis par l’enseignant,
          très contagieux, mais portant un masque chirurgical.
        </>
      )
    }
  ],
  szenarioSelectOptions: [
    { name: 'Warteraum', value: 0 },
    { name: 'Klassenzimmer', value: 1 },
    { name: 'Weihnachsfeier', value: 2 }
  ],
  parameters: {
    emitterType: [
      {
        name: 'Élevé',
        desc: 'une personne sur trois',
        value: 'high'
      },
      {
        name: 'Très élevé',
        desc: 'une personne sur dix',
        value: 'very'
      },
      {
        name: 'Superélevé',
        desc: 'une personne sur trente',
        value: 'super'
      }
    ],
    criticalDose: [
      { name: 'Pas particulièrement vulnérable', value: 500 },
      { name: 'Particulièrement vulnérable', value: 50 }
    ],
    roomVolume: [
      { name: '50m³', desc: 'par ex. une salle d’attente', value: 50 },
      { name: '100m³', desc: 'par ex. un magasin', value: 100 },
      { name: '150m³', desc: 'par ex. une salle de classe', value: 150 },
      { name: '300m³', desc: 'par ex. un restaurant', value: 300 },
      { name: '3000m³', desc: 'par ex. un supermarché', value: 3000 }
    ],
    airExchangeRate: [
      { name: 'Pas aérer', desc: '', value: 0.2 },
      { name: 'Aérer régulièrement', desc: 'toutes les 30 minutes', value: 2 },
      { name: 'Faible ventilation', desc: 'peu de personnes/m²', value: 1.5 },
      { name: 'Forte ventilation', desc: 'beaucoup de personnes/m²', value: 6 }
    ],
    timeInRoom: [
      { name: '5 minutes', value: 5 },
      { name: '15 minutes', value: 15 },
      { name: '45 minutes', value: 45 },
      { name: '90 minutes', value: 90 },
      { name: '180 minutes', value: 180 }
    ],
    maskEfficiencyExhaled: [
      { name: 'Pas de masque', value: 0 },
      { name: 'Tissu', value: 0.25 },
      { name: 'Masque chirurgical', value: 0.75 },
      { name: 'FFP2', value: 0.8 }
    ],
    maskEfficiencyInhaled: [
      { name: 'Pas de masque', value: 0 },
      { name: 'Tissu', value: 0.25 },
      { name: 'Masque chirurgical', value: 0.75 },
      { name: 'FFP2', value: 0.95 }
    ],
    activityLevel: [
      { name: 'Léger', value: 'low' },
      { name: 'Moyen', value: 'medium' },
      { name: 'Élevé', value: 'high' }
    ],
    voiceStrengths: [
      { name: 'Muet', value: [1, 0, 0] },
      { name: 'Parler doucement, chuchoter', value: [0.9, 0.1, 0] },
      { name: 'Discussion', value: [0.4, 0.5, 0.1] },
      { name: 'Chanter', value: [0.3, 0, 0.7] }
    ]
  },
  parameterText: {
    criticalDose: {
      t: <>Êtes-vous particulièrement vulnérable?</>,
      d: (
        <>
          Avez-vous plus de 60 ans ou souffrez-vous de maladies préexistantes
          comme l'hypertension, le diabète ou le cancer? L'infection peut alors
          déjà se produire après avoir inhalé seulement 50 virus. D’habitude, il
          faut atteindre un seuil d’environ 500 virus pour risquer une
          infection.
        </>
      )
    },
    roomVolume: {
      t: <>Quelle est la taille de la pièce?</>,
      d: (
        <>
          Plus le volume de la pièce est important, plus le risque d'infection
          par les aérosols est faible: la quantité de virus expirée est mieux
          répartie et il est plus facile de maintenir de la distance.
        </>
      )
    },
    airExchangeRate: {
      t: <>Comment la pièce est-elle aérée?</>,
      d: (
        <>
          Lorsqu’un système de ventilation est conçu pour quelques personnes
          uniquement (par exemple dans un petit magasin), l’air de la pièce est
          totalement renouvelé 1,5 fois par heure. Un système destiné à de
          nombreuses personnes (par exemple dans un restaurant) renouvelle
          complètement l’air jusqu’à 6 fois par heure.
        </>
      )
    },
    timeInRoom: {
      t: <>Combien de temps les personnes restent-elles dans la pièce?</>,
      d: (
        <>
          Durant ce laps de temps, la personne en bonne santé est exposée aux
          aérosols expirés par la personne infectée, présente avec elle dans la
          même pièce.
        </>
      )
    },
    emitterType: {
      t: <>Quel risque de contagion émane d’une personne infectée?</>,
      d: (
        <>
          Le potentiel de contagion d'une personne infectée est variable:
          certaines personnes expirent beaucoup de virus, d'autres moins. Parmi
          ces gens, les propagateurs à risque élevé sont dix fois plus fréquents
          que les «superpropagateurs». Or ceux-ci peuvent expirer 322 fois plus
          de virus lorsqu'ils parlent qu’un propagateur à risque élevé.
        </>
      )
    },

    maskEfficiencyExhaled: {
      t: <>Quel type de masque porte la personne infectée?</>,
      d: (
        <>
          L’efficacité pendant l’expiration est primordiale lorsqu’on
          s'intéresse au masque porté par la personne infectée. Elle peut être
          de 25% pour un masque en tissu et aller jusqu’à 80% pour un masque
          FFP2.
        </>
      )
    },
    maskEfficiencyInhaled: {
      t: <>Quel type de masque portent les personnes en bonne santé?</>,
      d: (
        <>
          L’efficacité pendant l’inspiration est primordiale lorsqu’on
          s’intéresse au masque porté par les personnes en bonne santé. Elle
          peut être de 25% pour un masque en tissu et aller jusqu’à 95% pour un
          masque FFP2.
        </>
      )
    },
    activityLevel: {
      t: (
        <>
          Quel est le niveau d’activité physique des personnes présentes dans la
          pièce?
        </>
      ),
      d: (
        <>
          Plus l'activité dans la pièce est importante, plus on respire. Une
          personne infectée expire alors davantage de virus et les autres
          personnes respirent un air contenant davantage de virus.
        </>
      )
    },
    voiceStrengths: {
      t: (
        <>Est-ce que les gens parlent ou chantent à l’intérieur de la pièce?</>
      ),
      d: (
        <>
          En parlant, l’air que nous respirons bouge. Cela favorise la formation
          d’un plus grand nombre d’aérosols infectieux dans les poumons, les
          cordes vocales et les lèvres. Ces aérosols sont ensuite libérés dans
          la pièce.
        </>
      )
    }
  },
  parameterOrder: [
    'criticalDose',
    'roomVolume',
    'timeInRoom',
    'emitterType',
    'airExchangeRate',
    'maskEfficiencyExhaled',
    'maskEfficiencyInhaled',
    'activityLevel',
    'voiceStrengths'
  ]
}
